'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Separator } from '@achra/ui/separator';
import { FilterDrawer } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { SearchInput } from '@/modules/shared/components/form/search-input';
import { BuilderSkillsSelect, BuilderSkillsSelectDrawer } from './builder-skills-select';
import { useBuildersFiltersContext } from './builders-filters-context';
function BuilderFilters() {
  const $ = _c(32);
  const {
    search,
    skills,
    isSearchPending,
    isSkillsPending,
    isResetPending,
    isResetDisabled,
    setSearch,
    setSkills,
    onReset
  } = useBuildersFiltersContext();
  const t0 = isResetPending || isSearchPending || isSkillsPending;
  let t1;
  if ($[0] !== setSearch) {
    t1 = value => {
      setSearch(value);
    };
    $[0] = setSearch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isResetPending || $[3] !== isSearchPending || $[4] !== search || $[5] !== t1) {
    t2 = <SearchInput value={search} onChange={t1} placeholder="Search..." isLoading={isSearchPending} disabled={isResetPending} />;
    $[2] = isResetPending;
    $[3] = isSearchPending;
    $[4] = search;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isResetPending || $[8] !== isSkillsPending || $[9] !== setSkills || $[10] !== skills) {
    t3 = <BuilderSkillsSelect skills={skills} setSkills={setSkills} className="w-69" isLoading={isSkillsPending} disabled={isResetPending} />;
    $[7] = isResetPending;
    $[8] = isSkillsPending;
    $[9] = setSkills;
    $[10] = skills;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isResetDisabled || $[13] !== onReset) {
    t4 = <Button className="text-foreground/50 px-4 hover:bg-transparent dark:hover:bg-transparent" variant="ghost" onClick={onReset} disabled={isResetDisabled}>Reset Filter</Button>;
    $[12] = isResetDisabled;
    $[13] = onReset;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="hidden items-center gap-2 md:flex lg:gap-4">{t3}{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator orientation="vertical" className="h-7!" />;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== setSkills || $[20] !== skills) {
    t7 = <BuilderSkillsSelectDrawer skills={skills} setSkills={setSkills} />;
    $[19] = setSkills;
    $[20] = skills;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== isResetDisabled || $[23] !== isResetPending || $[24] !== onReset || $[25] !== t7) {
    t8 = <div className="flex items-center gap-4 md:hidden">{t6}<FilterDrawer onReset={onReset} isResetDisabled={isResetDisabled} isResetPending={isResetPending}>{t7}</FilterDrawer></div>;
    $[22] = isResetDisabled;
    $[23] = isResetPending;
    $[24] = onReset;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t0 || $[28] !== t2 || $[29] !== t5 || $[30] !== t8) {
    t9 = <div className="grid grid-cols-[1fr_auto] gap-4 md:grid-cols-[1fr_400px] lg:gap-6" aria-busy={t0}>{t2}{t5}{t8}</div>;
    $[27] = t0;
    $[28] = t2;
    $[29] = t5;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}
export { BuilderFilters };